export async function fetchJson(url: string) {
    const result = await fetch(url)

    const jsonResult = await result.json()

    if (result.status !== 200) {
        try {
            window.location.href = jsonResult.location
        } catch (err) {
            console.error(err)
        }
    }

    if (jsonResult.ok) {
        return [jsonResult]
    }
    return [jsonResult, new Error("Fetch failed.")]
}
